<template>
    <div class="sequenceInterception-div">
        <div>
            <h2 style="text-align: center;padding-top: 20px;font-size: 30px;color: #407338">Genomic sequence retrieval</h2>
        </div>
        <div class="search-form">
            <h2 style="text-align: center;margin-top: 20px;font-size: 22px;color: #407338;">Search across coordinates</h2>
            <el-form class="demo-form-inline" style="margin-top: 15px;" size="small" @submit.native.prevent label-width="120px">
                <el-form-item style="text-align: left" label="genome">
                    <el-select style="width: 180px;margin-right: 7px" v-model="search_genome">
                        <template v-for="genome in genome_sheet">
                            <el-option v-if="genome.species != 'All'" :key="genome" :label="genome.species" :value="genome.species"></el-option>
                        </template>
                    </el-select>
                </el-form-item>

                <el-form-item style="text-align: left" label="chromosome">
                    <el-select style="width: 180px;margin-right: 7px" v-model="search_chromosome">
                        <template v-for="chromosome in chromosome_sheet">
                            <el-option :key="chromosome" :label="chromosome.Chr" :value="chromosome.Chr"></el-option>
                        </template>
                    </el-select>
                </el-form-item>

                <el-form-item label="start position">
                    <el-input style="width: 180px" v-model="startPos" placeholder="start position"></el-input>
                </el-form-item>

                <el-form-item label="end position">
                    <el-input style="width: 180px" v-model="endPos" placeholder="end position" @keyup.enter.native="search_fragment"></el-input>
                </el-form-item>

                <el-form-item style="text-align: left" label="strand">
                    <el-select style="width: 180px;margin-right: 7px" v-model="strand">
                        <el-option label="+" value="+"></el-option>
                        <el-option label="-" value="-"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item style="text-align: left">
                    <el-button style="width: 85px" type="primary" @click="search_fragment"><b>Search</b></el-button>
                    <el-button style="width: 65px;margin-left: 30px" type="primary" @click="example_help">Help</el-button>
                </el-form-item>

                <el-form-item style="text-align: left; margin-left: -30px" label="example">
                    <el-button style="width: 210px;font-size: 10px" type="primary" @click="example1">Ath_TAIR_V10.1 Chr1:3760..3913</el-button>
                </el-form-item>

                <el-form-item v-if="show_result">
                    <el-button style="width: 280px;font-weight: bold;margin-left: -100px" @click="download_seq">Download as fasta</el-button>
                </el-form-item>
            </el-form>

        </div>

        <div class="seqinterception-box" v-if="show_result">
            <a style="color: #407338">{{aim_fragment.gene_ID}}<br/>{{aim_fragment.Seq}}</a>
        </div>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: "SequenceInterception",
        data() {
            return {
                search_chromosome: '',
                startPos: '',
                endPos: '',
                strand: '',
                search_genome: '',
                genome_sheet: {},
                chromosome_sheet: {},
                aim_fragment: '',
                show_result: 0,
            }
        },
        mounted() {
            this.judgeStyle();
            this.get_genomes_show()
        },
        methods: {
            judgeStyle() {
                if (document.documentElement.clientHeight <= document.body.clientHeight) {
                    document.getElementsByTagName('html')[0].style.height = '';
                    document.getElementsByTagName('body')[0].style.height = '';
                } else {
                    document.getElementsByTagName('html')[0].style.height = '100%';
                    document.getElementsByTagName('body')[0].style.height = '100%';
                }
            },
            get_genomes_show() {
                axios({
                    url:'http://39.100.233.196:8001/api/get-species-information/',
                    type: 'json',
                    method: 'get',
                }).then((res)=>{
                    // console.log(res.data);
                    this.genome_sheet = res.data
                })
            },
            search_fragment() {
                this.show_result = 0
                const search_chromosome = this.search_chromosome;
                const startPos = this.startPos;
                const endPos = this.endPos;
                const strand = this.strand;
                const search_genome = this.search_genome;
                axios({
                    url: 'http://39.100.233.196:8001/api/get-fragment/',
                    type: 'json',
                    timeout: 30000,
                    params: {
                        search_chromosome,
                        startPos,
                        endPos,
                        strand,
                        search_genome
                    },
                    method: 'get',
                }).then((res)=>{
                    // console.log(res.data);
                    this.aim_fragment = res.data[0];
                    this.show_result = 1;
                })
            },
            example_help() {
                this.$router.push({path: '../Userguide/'})
            },
            example1() {
                this.search_chromosome = 'Chr1';
                this.startPos = '3760';
                this.endPos = '3913';
                this.strand = '+';
                this.search_genome = 'Ath_TAIR_V10.1';
                this.search_fragment();
            },
            download_seq() {
                // console.log('OKOKOOK')
                let content = new Blob([this.aim_fragment.download])
                //生成url对象
                let  urlObject = window.URL || window.webkitURL || window
                let url = urlObject.createObjectURL(content)
                //生成<a></a>DOM元素
                let el = document.createElement('a')
                //链接赋值
                el.href = url
                el.download = this.aim_fragment.gene_ID + ".fa";
                //必须点击否则不会下载
                el.click()
                //移除链接释放资源
                urlObject.revokeObjectURL(url)
            },
        },
        watch: {
            'search_genome': {
                handler: function (val) {
                    if (val.length != 0) {
                        const search_genome = this.search_genome;
                        axios({
                            url: 'http://39.100.233.196:8001/api/get-chromosome/',
                            type: 'json',
                            timeout: 30000,
                            params: {
                                search_genome
                            }
                        }).then((res)=>{
                            // console.log(res.data);
                            this.chromosome_sheet = res.data
                        })
                    }
                },
            },
        }
    }
</script>

<style>

    .sequenceInterception-div {
        overflow:auto;
        background: #E8F2EC;
        width: 1200px;
        margin: 0 auto;
    }

    .sequenceInterception-div .search-form {
        float: left;
        margin: 50px auto 5px 50px;
        width: 350px;
        height: 500px;
        border-right: 1px solid #407338;
    }

    .sequenceInterception-div .search-form .el-form-item__label {
        color: #407338;
    }

    .sequenceInterception-div .search-form .el-button {
        background-color: #E1E1E1;
        color: #407338;
        border: #ADADAD;
        font-size: 16px;
    }

    .sequenceInterception-div .search-form .el-button:hover {
        background-color: #E5F1FB;
        color: black;
    }

    .sequenceInterception-div .annotation-result .el-button {
        background-color: #E1E1E1;
        color: #407338;
        border: #ADADAD;
        font-size: 16px;
    }

    .sequenceInterception-div .annotation-result .el-button:hover {
        background-color: #E5F1FB;
        color: #407338;
    }

    #waiting {
        text-align: center;
        position: fixed;
        width: 200px;
        height: 200px;
        /*background: rgba(119, 176, 127, 0.35);*/
        left: 0;
        right: 0;
        top: 35%;
        margin: 0 auto;
    }

    .sequenceInterception-div .el-select-dropdown__item {
        color: #407338;
    }

    .sequenceInterception-div .el-input__inner {
        color: #407338;
    }

    .sequenceInterception-div .seqinterception-box {
        margin: 50px auto 8px 30px;
        float: left;
        padding: 8px;
        border: solid 1px #407338;
        height: 480px;
        width: 720px;
        word-wrap:break-word;
        word-break:break-all;
        overflow-y: auto;
    }

</style>